import { c as _c } from "react/compiler-runtime";
import { MERKL_DASHBOARD_URL, ZERO } from '@morpho-org/dapp-core';
import { ExternalLink } from '@morpho-org/ui-v6/server';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Button } from '@repo/ui';
import { ArrowDiagonalUp, Rewards } from '@repo/ui/icons';
import { memo, useMemo } from 'react';
import { useRewardContext } from '@/contexts/Reward/Reward.context';
import { useWeb3Context } from '@/contexts/Web3Context';
import { calculateRewardSum, isRewardSumFullyPriced } from '@/helpers/reward/calculateRewardSum';
import { trackRewardsClaimClicked } from '@/lib/analytics/client/trackers/reward';
const DashboardRewardButton = () => {
  const $ = _c(15);
  const {
    account
  } = useWeb3Context();
  const rewardData = useRewardContext();
  let t0;
  if ($[0] !== rewardData.display.rewardsMerged) {
    t0 = calculateRewardSum(rewardData.display.rewardsMerged);
    $[0] = rewardData.display.rewardsMerged;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const totalRewardClaimable = t0;
  let t1;
  if ($[2] !== totalRewardClaimable) {
    t1 = formatters.short.digits(2).default("0").unit("$").of(totalRewardClaimable, 18);
    $[2] = totalRewardClaimable;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const formattedTotalRewardClaimable = t1;
  let t2;
  if ($[4] !== rewardData.display.rewardsMerged || $[5] !== totalRewardClaimable) {
    t2 = () => {
      trackRewardsClaimClicked({
        source: "dashboard_button",
        claimableUsdRaw: isRewardSumFullyPriced(rewardData.display.rewardsMerged) ? totalRewardClaimable : undefined
      });
    };
    $[4] = rewardData.display.rewardsMerged;
    $[5] = totalRewardClaimable;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleClaimClick = t2;
  if (!account || !rewardData || totalRewardClaimable === ZERO) {
    return null;
  }
  const t3 = `${MERKL_DASHBOARD_URL}/${account.address}`;
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Rewards />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = `Claim ${formattedTotalRewardClaimable}`;
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ArrowDiagonalUp />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <Button>{t4}{t5}{t6}</Button>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== handleClaimClick || $[12] !== t3 || $[13] !== t7) {
    t8 = <ExternalLink data-testid="claim-merkl-button" href={t3} onClick={handleClaimClick}>{t7}</ExternalLink>;
    $[11] = handleClaimClick;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
export default memo(DashboardRewardButton);